import { CanAccess } from '@modules/common/components/CanAccess';
import { EditIntegrationChannelDrawer } from '@modules/integrationsV2/components/EditIntegrationChannelDrawer';
import { getIsIntegrationChannelsMetadataSupported } from '@modules/integrationsV2/utils';
import { EditRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import {
  DescriptionMap,
  IntegrationChannelViewFragment,
  IntegrationType,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { useState } from 'react';

interface EditIntegrationChannelCTAProps {
  integrationID: string;
  integrationChannel: IntegrationChannelViewFragment;
  integrationType: IntegrationType;
  channelID: string;
  channelName: string;
  channelDescriptions: DescriptionMap[];
}

export const EditIntegrationChannelCTA = ({
  integrationID,
  integrationChannel,
  integrationType,
  channelID,
  channelName,
  channelDescriptions,
}: EditIntegrationChannelCTAProps) => {
  const [
    isEditIntegrationChannelDrawerOpen,
    setIsEditIntegrationChannelDrawerOpen,
  ] = useState(false);

  const isIntegrationChannelsMetadataSupported =
    getIsIntegrationChannelsMetadataSupported(integrationChannel.type);

  if (!isIntegrationChannelsMetadataSupported) {
    return null;
  }

  const openEditIntegrationChannelDrawer = () => {
    setIsEditIntegrationChannelDrawerOpen(true);
  };

  const closeEditIntegrationChannelDrawer = () => {
    setIsEditIntegrationChannelDrawerOpen(false);
  };

  return (
    <>
      <CanAccess
        resource={PermissionResource.Integration}
        operation={PermissionOperation.Write}
      >
        <Button
          size="small"
          startIcon={<EditRounded />}
          onClick={openEditIntegrationChannelDrawer}
        >
          Edit
        </Button>
      </CanAccess>
      <EditIntegrationChannelDrawer
        isOpen={isEditIntegrationChannelDrawerOpen}
        integrationChannel={integrationChannel}
        onDrawerClose={closeEditIntegrationChannelDrawer}
        integrationID={integrationID}
        integrationType={integrationType}
        channelID={channelID}
        channelName={channelName}
        channelDescriptions={channelDescriptions}
      />
    </>
  );
};
